import React from "react";
import { Box } from "theme-ui";

function SubTitle({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        color: "#000",
        fontSize: "16px",
        fontWeight: "bold",
        marginBottom: "10px",
      }}
    >
      {children}
    </Box>
  );
}

export default SubTitle;
